(() => {
  if (window.__NVL_182_POLISH__) return;
  window.__NVL_182_POLISH__ = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  document.querySelectorAll('[data-nvp-maxperf]').forEach((section) => {
    const steps = [...section.querySelectorAll('[data-nvp-maxperf-step]')];
    const scenes = [...section.querySelectorAll('[data-nvp-maxperf-scene]')];
    const dots = [...section.querySelectorAll('[data-nvp-maxperf-dot]')];
    const label = section.querySelector('[data-nvp-maxperf-label]');
    const labels = ['FRAME DELIVERY', 'NETWORK PATH', 'SYSTEM RESPONSE'];
    let active = 0;

    const setActive = (index) => {
      if (index < 0 || index >= steps.length || index === active && scenes[index]?.classList.contains('is-active')) return;
      active = index;
      steps.forEach((el, i) => el.classList.toggle('is-active', i === index));
      scenes.forEach((el, i) => el.classList.toggle('is-active', i === index));
      dots.forEach((el, i) => el.classList.toggle('is-active', i === index));
      if (label) label.textContent = labels[index] || '';
    };
    setActive(0);

    steps.forEach((step, index) => {
      step.addEventListener('focus', () => setActive(index));
      step.addEventListener('click', () => setActive(index));
      if (finePointer) step.addEventListener('mouseenter', () => setActive(index));
    });

    if ('IntersectionObserver' in window && !reduceMotion) {
      const observer = new IntersectionObserver((entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) setActive(Number(visible.target.dataset.nvpMaxperfStep || 0));
      }, { threshold: [.35, .55, .72], rootMargin: '-22% 0px -38% 0px' });
      steps.forEach((step) => observer.observe(step));
    }
  });

  const valueAt = (obj, path) => path.split('.').reduce((acc, key) => acc == null ? undefined : acc[key], obj);
  const avatarFrom = (account) => {
    if (!account) return '';
    const directPaths = [
      'avatar_url','avatarUrl','provider_avatar_url','providerAvatar','picture','avatar',
      'user_metadata.avatar_url','user_metadata.picture','metadata.avatar_url','metadata.picture',
      'identity_data.avatar_url','identity_data.picture','identity.identity_data.avatar_url','identity.identity_data.picture',
      'user.user_metadata.avatar_url','user.user_metadata.picture','profile.avatar_url','profile.picture',
      'provider.avatar_url','provider.picture','discord.avatar_url','google.picture'
    ];
    for (const path of directPaths) {
      const value = valueAt(account, path);
      if (typeof value === 'string' && /^https?:\/\//i.test(value)) return value;
    }
    const identities = Array.isArray(account.identities) ? account.identities : Array.isArray(account.user?.identities) ? account.user.identities : [];
    for (const identity of identities) {
      const data = identity?.identity_data || identity?.data || identity?.user_metadata || {};
      for (const key of ['avatar_url','picture','avatar']) {
        const value = data?.[key];
        if (typeof value === 'string' && /^https?:\/\//i.test(value)) return value;
      }
    }
    return '';
  };
  const accountName = (account) => account?.username || account?.display_name || account?.displayName || account?.name || account?.full_name || account?.user_metadata?.full_name || account?.user_metadata?.name || account?.email || 'NVL';
  const initials = (account) => {
    const name = String(accountName(account)).trim();
    if (!name) return 'N';
    const words = name.replace(/@.*/, '').split(/[\s._-]+/).filter(Boolean);
    return words.length > 1 ? `${words[0][0]}${words[1][0]}`.toUpperCase() : name[0].toUpperCase();
  };

  const paintAvatar = (root, account) => {
    const img = root.querySelector('[data-nvp-account-avatar]');
    const fallback = root.querySelector('[data-nvp-account-fallback]');
    if (!img || !fallback) return;
    const text = initials(account);
    fallback.textContent = text;
    fallback.hidden = false;
    const url = avatarFrom(account);
    if (!url) {
      img.hidden = true;
      img.removeAttribute('src');
      return;
    }
    img.hidden = true;
    const showImage = () => { if (img.naturalWidth > 0) { img.hidden = false; fallback.hidden = true; } };
    const showFallback = () => { img.hidden = true; fallback.hidden = false; };
    img.onload = showImage;
    img.onerror = showFallback;
    if (img.src !== url) img.src = url;
    else if (img.complete) showImage();
  };

  let avatarSyncing = false;
  const syncProviderAvatars = async () => {
    if (avatarSyncing || !window.NVLStore?.me) return;
    avatarSyncing = true;
    try {
      const account = await window.NVLStore.me();
      if (account) document.querySelectorAll('[data-nvp-account]').forEach((root) => paintAvatar(root, account));
    } catch (_) {} finally { avatarSyncing = false; }
  };

  [80, 700, 1800].forEach((delay) => setTimeout(syncProviderAvatars, delay));
  window.addEventListener('focus', () => setTimeout(syncProviderAvatars, 180));
  document.addEventListener('visibilitychange', () => { if (!document.hidden) setTimeout(syncProviderAvatars, 180); });
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-nvp-account-trigger], [data-nvp-account-login], [data-provider]')) {
      setTimeout(syncProviderAvatars, 500);
      setTimeout(syncProviderAvatars, 1800);
    }
  });
})();
